import React, { FC, memo, ReactNode } from "react";

import { IFetcherRenderProps, LazyImg } from "@/components/Fetcher";
import { IAttachment } from "@/data/attachments";

export interface ILazyLoadedLogoProps {
  logo?: IAttachment | null;
  children: (publicUrl?: string | null) => ReactNode;
}

export const LazyLoadedLogo: FC<ILazyLoadedLogoProps> = memo(({ logo, children }) => {
  return (
    <>
      {!logo ? (
        children()
      ) : logo.publicUrl ? (
        children(logo.publicUrl)
      ) : (
        <LazyImg key={logo.id} systemId={logo.systemId}>
          {({ payload }: IFetcherRenderProps<IAttachment>) => children(payload?.publicUrl)}
        </LazyImg>
      )}
    </>
  );
});
